import { NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { RouterModule, Router } from '@angular/router';
import { NetworkService } from '../../services/network.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { ReCaptchaV3Service, RecaptchaModule, RecaptchaComponent } from 'ng-recaptcha';
import { FortgotPasswordComponent } from './login/fortgot-password/fortgot-password.component';
import { RegisterComponent } from './login/register/register.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BrowserModule } from '@angular/platform-browser';
import { GlobalComponentsModule } from '../../global-components/global-components/global-components.module';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  imports: [
    CommonModule, RouterModule.forChild([
      { path: '', component: LoginComponent }
    ]),
    GlobalComponentsModule,
    MatFormFieldModule, ReactiveFormsModule, MatInputModule, MatButtonModule, MatCardModule,
    MatIconModule, MatCheckboxModule, RecaptchaModule, GlobalComponentsModule, MatInputModule,
    FormsModule, ReactiveFormsModule, MatPasswordStrengthModule, MatSnackBarModule
  ],
  declarations: [LoginComponent, FortgotPasswordComponent, RegisterComponent],
  providers: [NetworkService],
  exports: [RecaptchaModule]
})
export class IndexModule {
  constructor(private networkService: NetworkService, private router: Router){}
 }